// Toggle open/close News/Events filter
export function filterToggle() {
  const filter = document.querySelector(".button-filter");

  const body = document.body;

  body.classList.add("filter-closed");

  if (!filter) {
    return;
  }

  function toggleFilter() {
    body.classList.toggle("filter-open");
    body.classList.toggle("filter-closed");
  }

  document
    .querySelectorAll(".button-filter, .button-filter-exit")
    .forEach((button) => {
      button.addEventListener("click", toggleFilter);
    });

  document.addEventListener("click", function (event) {
    const isFilterElement =
      event.target.matches(".filter-sidebar, .button-filter") ||
      event.target.closest(".filter-sidebar");
    if (!isFilterElement) {
      body.classList.remove("filter-open");
      body.classList.add("filter-closed");
    }
  });
}
